module.exports = {
  sanity: {
    projectId: 'y92ikqct' || process.env.SANITY_STUDIO_API_PROJECT_ID,
    dataset: 'develop' || process.env.SANITY_STUDIO_API_DATASET,
  },
};
